export default {
  "首页": "Home",
  "订单": "Ordine",
  "新闻": "Notizie",
  "个人中心": "Centro Personale",
  "模拟账户": "Conto Demo",
  "可用资产": "Asset Disponibili",
  "入金": "Deposito",
  "出金": "Prelievo",
  "账单详情": "Dettagli Fattura",
  "重置模拟账户": "Reimposta Conto Demo",
  "钱包": "Portafoglio",
  "实名认证": "Verifica dell'Identità",
  "邀请好友": "Invita Amici",
  "修改密码": "Cambia Password",
  "投诉邮箱": "Email Reclami",
  "其它": "Altro",
  "公告": "Annunci",
  "语言": "Lingua",
  "是否退出登录": "Vuoi uscire?",
  "复制": "Copia",
  "复制成功": "Copia Avvenuta",
  "发送验证码成功": "Codice di Verifica Inviato",
  "请输入密码": "Inserisci la Password",
  "请再次输入密码": "Inserisci nuovamente la Password",
  "复制邀请链接": "Copia Link di Invito",
  "上传身份": "Carica il fronte/retro del passaporto/documento",
  "正面": "Fronte",
  "上传正面": "Carica il Fronte del Passaporto/Documento",
  "反面": "Retro",
  "上传反面": "Carica il Retro del Passaporto/Documento",
  "完善信息": "Completa le Informazioni Personali",
  "输入姓名": "Inserisci il Nome",
  "身份证号": "Numero del Passaporto/Documento",
  "输入身份证号": "Inserisci il Numero del Passaporto/Documento",
  "收款货币": "Valuta Ricevuta",
  "银行名称": "Nome della Banca",
  "收款人账户": "Conto del Beneficiario",
  "货币": "Valuta",
  "分店名称": "Nome della Filiale",
  "绑定银行卡": "Collega la Carta Bancaria",
  "银行地址": "Indirizzo della Banca",
  "账号名称（假名）": "Nome Account (Alias)",
  "绑定数字货币地址": "Collega l'Indirizzo di Criptovaluta",
  "余额": "Saldo",
  "联系客服": "Contatta il Servizio Clienti",
  "行情": "Mercato",
  "其他": "Altro",
  "设置": "Impostazioni",
  "收款人": "Beneficiario",
  "添加": "Aggiungi",
  "确认": "Conferma",
  "取消": "Annulla",
  "钱包地址": "Indirizzo del Portafoglio",
  "请输入": "Inserisci",
  "退出登录": "Esci",
  "充值数量": "Quantità di Ricarica",
  "提交": "Invia",
  "银行卡": "Carta Bancaria",
  "选择网络": "Seleziona Rete",
  "数字货币": "Criptovaluta",
  "上传验证": "Carica Verifica",
  "提币地址": "Indirizzo di Prelievo",
  "数量(USD)": "Quantità (USD)",
  "备注": "Nota",
  "手续费": "Commissione",
  "预计到账数量": "Quantità Stimata in Arrivo",
  "暂无数据": "Nessun Dato",
  "入金记录": "Registro Depositi",
  "提币记录": "Registro Prelievi",
  "验证码": "Codice di Verifica",
  "邀请码": "Codice di Invito",
  "提示": "Promemoria",
  "请输入验证码": "Inserisci il Codice di Verifica",
  "姓名": "Nome",
  "邮箱登录": "Accesso Email",
  "邮箱": "Email",
  "密码": "Password",
  "新用户": "Nuovo Utente",
  "立即加入": "Iscriviti Ora",
  "忘记密码": "Password Dimenticata",
  "登录": "Accedi",
  "无需开户,立即创建模拟账号进行交易!": "Nessun Conto Necessario, Crea un Conto Demo per Iniziare a Fare Trading!",
  "电话": "Telefono",
  "再次输入密码": "Reinserisci la Password",
  "职业": "Professione",
  "年收入": "Reddito Annuale",
  "注册": "Registrati",
  "邮箱注册": "Registrazione Email",
  "发送": "Invia",
  "重置密码": "Reimposta Password",
  "是否重置": "Vuoi Reimpostare?",
  "已重置": "Reimpostato",
  "名称": "Nome",
  "注册成功": "Registrazione Avvenuta",
  "加载中": "Caricamento in Corso",
  "您还未登录，请先登录": "Non hai effettuato l'accesso, effettua l'accesso prima",
  "退出成功": "Uscita Avvenuta",
  "市价": "Prezzo di Mercato",
  "挂单": "Ordine Limitato",
  "倍数": "Moltiplicatore",
  "止盈": "Take Profit",
  "止损": "Stop Loss",
  "买入数量": "Quantità Acquistata",
  "每手": "Per Lotto",
  "预估手续费": "Commissioni Stimate",
  "预估保证金": "Margine Stimato",
  "买入": "Acquista",
  "卖出": "Vendi",
  "您的订单已确认": "Il tuo ordine è stato confermato",
  "订单页面": "Pagina Ordine",
  "盈亏": "Profitti/Perdite",
  "当前保证金": "Margine Attuale",
  "订单详情": "Dettagli Ordine",
  "保证金": "Margine",
  "平仓": "Chiudi Posizione",
  "修改": "Modifica",
  "手数": "Lotti",
  "暂无数据": "Nessun Dato",
  "历史": "Storico",
  "价格": "Prezzo",
  "请输入价格": "Inserisci il Prezzo",
  "手": "Lotto",
  "搜索结果": "Risultati di Ricerca",
  "搜索产品": "Cerca Prodotto",
  "持仓": "Posizione",
  "语言": "Lingua",
  "审核中": "In Revisione",
  "请上传证件照正/反面": "Carica foto fronte/retro del documento",
  "上传成功": "Caricamento Avvenuto",
  "上传失败": "Caricamento Fallito",
  "提交成功": "Inviato con Successo",
  "删除": "Elimina",
  "删除成功": "Eliminazione Avvenuta",
  "提币": "Prelievo Criptovaluta",
  "缺少参数或传值错误": "Parametri Mancanti o Errore di Valore",
  "操作成功": "Operazione Avvenuta",
  "充值金额": "Importo di Ricarica",
  "类型": "Tipo",
  "状态": "Stato",
  "时间": "Orario",
  "单位": "Unità",
  "最高价": "Prezzo Massimo",
  "最低价": "Prezzo Minimo",
  "开盘价": "Prezzo di Apertura",
  "请注册或登录真实账号": "Registrati o Accedi al Conto Reale",
  "没有更多了": "Niente Altro",
  "提现金额": "Importo Prelievo",
  "审核通过": "Approvato",
  "审核不通过": "Non Approvato",
  "重新提交": "Reinvia",
  "止盈价": "Prezzo Take Profit",
  "止损价": "Prezzo Stop Loss",
  "总盈亏": "Profitto/Perdita Totale",
  "撤单": "Annulla Ordine",
  "请先进行实名认证": "Completa prima la Verifica dell'Identità",
  "产品列表": "Lista dei Prodotti",
  "下单": "Effettua Ordine",
  "可用资金": "Fondi Disponibili",
  "欢迎登录": "Benvenuto",
  "可用": "Disponibile",
  "冻结": "Bloccato",
  "财务记录": "Registro Finanziario",
  "交易对": "Coppie di Trading",
  "开仓时间": "Ora di Apertura",
  "收益": "Guadagno",
  "操作": "Azione",
  "下单价": "Prezzo Ordine",
  "当前价": "Prezzo Attuale",
  "订单号": "Numero Ordine",
  "请选择": "Si prega di scegliere",
  "卖出(做空)止损价不能低于开仓价": "Il prezzo stop loss per vendere (short) non può essere inferiore al prezzo di apertura",
  "卖出(做多)止盈价不能高于开仓价": "Il prezzo take profit per vendere (long) non può essere superiore al prezzo di apertura",
  "买入(做多)止损价不能高于开仓价": "Il prezzo stop loss per comprare (long) non può essere superiore al prezzo di apertura",
  "买入(做多)止盈价不能低于开仓价": "Il prezzo take profit per comprare (long) non può essere inferiore al prezzo di apertura",
  "买入(做多)止盈价不能低于开仓价和现价": "Il prezzo take profit per comprare (long) non può essere inferiore al prezzo di apertura e al prezzo attuale",
  "买入(做多)止损价不能高于开仓价和现价": "Il prezzo stop loss per comprare (long) non può essere superiore al prezzo di apertura e al prezzo attuale",
  "卖出(做空)止损价不能低于开仓价和现价": "Il prezzo stop loss per vendere (short) non può essere inferiore al prezzo di apertura e al prezzo attuale",
  "卖出(做多)止盈价不能高于开仓价和现价": "Il prezzo take profit per vendere (long) non può essere superiore al prezzo di apertura e al prezzo attuale",

  "提现手续费": "Tassa di gestione dei prelievi",
  "提现退回": "Rimborso di prelievo",
  "系统加款": "Componenti aggiuntivi di sistema",
  "系统减款": "Riduzione del sistema",

  "交易周期": "Ciclo di transazione",
  "秒": "Secondo",
  "交易额": "Importo della transazione",
  "买涨": "Comprare in attesa di un aumento",
  "买跌": "Comprare in attesa di una caduta",
  "秒数": "Numero di secondi",
  "交易类型": "Tipo di transazione",
  "看涨": "Essere ottimista sull'aumento",
  "看跌": "Essere pessimista sull'aumento / Aspettare una caduta",
  "剩余时间": "Tempo rimanente",
  "买入价": "Prezzo di acquisto",
  "结算价": "Prezzo di liquidazione",
  "交易额": "Importo della transazione",
  "下单时间": "Ora di placed l'ordine",
  "结算时间": "Ora di liquidazione",
  "该币种暂无交易": "Attualmente non ci sono transazioni per questa valuta",

  "总资产": "Attività totali",
  "币种": "Valuta",
  "资产折合": "Conversione degli asset",
  "冻结金额": "Importo bloccato",
  "可用金额": "Importo disponibile",
  "公司资产": "Attività aziendali",
  "请输入旧密码": "Inserisci la vecchia password",
  "请输入新密码": "Inserisci la nuova password",
  "请再次输入新密码": "Inserisci nuovamente la nuova password",
  "白皮书": "Libro bianco",
  "注册证书": "Certificato di iscrizione",
  "MSB": "MSB",
  "上述信息最终解释权归官方所有": "Il diritto di interpretazione finale delle informazioni sopra indicate appartiene all'ufficio ufficiale.",
  "上一页": "Pagina precedente",
  "下一页": "Pagina successiva",
  "关闭": "Chiudi",
  "闪电兑换": "Scambio istantaneo",
  "全部": "Tutto",
  "可用余额": "Saldo disponibile",
  "到": "A",
  "请输入数量": "Inserisci la quantità",
  "币种选择": "Selezione della valuta",
  "从": "Da",
  "兑换": "Scambiare",
  "兑换成功！": "Scambio riuscito!",
  "支付": "Pagare",
  "全部兑换成功": "Tutti gli scambi sono stati eseguiti con successo",
  "获取": "Ottenere",
  "数量": "quantità",
  "拒绝原因": "Motivo del rifiuto",
  "交易密码": "Password di transazione",
  "设置交易密码": "Impostare la password di transazione",
  "重置交易密码": "Reimpostare la password di transazione",
  "确定": "Conferma",
  "是否购买？": "Acquistare?",
  "外汇": "Valuta estera",
  "期权": "Opzioni",
  "(用户中心)": "(Centro utente)",
  "您的交易正在处理中,请耐心等待交易完成再进行其他操作!": "La tua transazione è in fase di elaborazione, attendi pazientemente il completamento della transazione prima di eseguire altre operazioni!",
  "继续下单": "Continua l'ordine",
  "交易方向": "Direzione di trading",
  "实现盈利": "Realizzare profitto",
  "最新价格": "Prezzo più recente",
  "结算完成": "Liquidazione completata",
  "下单余额不足": "Saldo insufficiente per effettuare l'ordine",
  "输入交易额度": "Inserisci l'importo della transazione",
  "选择交易周期": "Seleziona il periodo di transazione",
  "审核拒绝": "Revisione rifiutata",
  "请输入正确的数量!": "Per favore inserisci la quantità corretta!",
  "上传身份": "Carica documento d'identità",
  "上传正面": "Carica lato anteriore",
  "上传反面": "Carica lato posteriore",
  "完善信息": "Completa le informazioni",
  "输入姓名": "Inserisci il nome",
  "输入身份证号": "Inserisci il numero di identificazione",
  "身份证号": "Numero di identificazione",
  "请上传证件照正/反面": "Si prega di caricare il fronte/retro del documento",
  "最小提现金额10USDT": "L'importo minimo per il prelievo è di 10 USDT",
  "证件号码": "Numero di identificazione",
  "输入证件号码": "Inserisci il numero di identificazione",
  "请上传身份证、驾驶证或护照其中一种进行身份认证！": "Carica la carta d'identità, la patente di guida o il passaporto per la verifica dell'identità!"


}
